export const statCodeStateList = ['NY', 'NM', 'TX'];
